import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, filter, map } from 'rxjs';
import { Constants } from '../../app.constants';
import { OidcService } from '../services/oidc.service';
import { LaunchContextService } from '../services/launch-context.service';

@Injectable({
  providedIn: 'root'
})
export class AutoLoginByConfigIdGuard {
  constructor(private oidcService: OidcService, private launchContextService: LaunchContextService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.oidcService.checkAuthDone$
      .pipe(
        filter((checkAuthDone: boolean) => !!checkAuthDone),
        map(() => {
          const isAuthenticated = this.oidcService.isAuthenticated$.value;

          if (!isAuthenticated) {
            const isReportRoute = this.targetIsReportRoute(route);

            // Guards on a route run concurrently, so skip authorize() here too - relying only
            // on launchContextGuard's own denial doesn't stop this guard's redirect from firing.
            if (isReportRoute && !this.hasLaunchContext()) {
              return false;
            }

            sessionStorage.setItem(Constants.WEB_STORAGE_KEY.REDIRECT, state.url);

            // Report routes ask the IDP silently (prompt=none); everything else redirects normally.
            this.oidcService.authorize(undefined, { silent: isReportRoute });
            return false;
          }

          return true;
        })
      );
  }

  private hasLaunchContext(): boolean {
    return this.launchContextService.hasReturnUrl() || this.launchContextService.hasHomeUrl();
  }

  private targetIsReportRoute(route: ActivatedRouteSnapshot): boolean {
    let node: ActivatedRouteSnapshot | null = route;
    while (node) {
      if (node.data?.['dceKey']) {
        return true;
      }
      node = node.firstChild;
    }
    return false;
  }
}
